<template>
  <!-- 日次締め -> 売掛金 -> 過不足精算表 Get exact same data from 全レジ金額の内訳計算表 and calculate data -->
  <el-table
    :data="blendData"
    :span-method="spanMethod"
    :row-class-name="rowClassName"
    class="egl-table excess-deficiency-settlement-table"
    stripe
    border
  >
    <!-- 売掛金種別 -->
    <el-table-column
      prop="type"
      :label="$locale('dailyClosing.accountsReceivableTable.excessDeficiencySettlementTable.th.accountsReceivableType')"
      width="140"
      align="center"
    >
      <template slot-scope="scope">
        <span v-if="scope.row.rowType !== 'total'" :class="[scope.row.rowType === 'subtotal' ? 'sub-total-row' : '' ]">
          {{ accountsReceivableType[scope.row.type] }}
        </span>
        <div v-else style="text-align: center">{{ scope.row.type }}</div>
      </template>
    </el-table-column>

    <!-- 売掛金名 -->
    <el-table-column
      prop="name"
      :label="$locale('dailyClosing.accountsReceivableTable.excessDeficiencySettlementTable.th.accountReceivableName')"
      width="180"
      align="center"
    >
      <template slot-scope="scope">
        {{ scope.row.name }}
      </template>
    </el-table-column>

    <!-- 日次実件数 -->
    <el-table-column
      prop="dayActualQty"
      :label="$locale('dailyClosing.accountsReceivableTable.excessDeficiencySettlementTable.th.dayActualQty')"
      width="110"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">
          {{ scope.row.dayActualQty | separatorFormatter((isInitData && !isEmptyData) && actionType !== "detail") }}
        </div>
      </template>
    </el-table-column>

    <!-- 合計過不足（件数） = レジ過不足（件数） + 日次過不足（件数） -->
    <el-table-column
      prop="insufficientTotal"
      :label="$locale('dailyClosing.accountsReceivableTable.excessDeficiencySettlementTable.th.insufficientTotal')"
      width="150"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">
          {{ scope.insufficientTotal | separatorFormatter((isInitData && !isEmptyData) && actionType !== "detail") }}
          <!-- {{ scope.row.cashQty + (scope.row.dayActualQty -  scope.row.actualQty) | separatorFormatter((isInitData && !isEmptyData) && actionType !== "detail") }} -->
        </div>
      </template>
    </el-table-column>

    <!-- レジ過不足（件数） -->
    <el-table-column
      prop="cashQty"
      :label="$locale('dailyClosing.accountsReceivableTable.excessDeficiencySettlementTable.th.cashQty')"
      width="150"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">
          {{ scope.row.cashQty | separatorFormatter((isInitData && !isEmptyData) && actionType !== "detail") }}
        </div>
      </template>
    </el-table-column>

    <!-- 日次過不足（件数） = 日次実件数 - レジ実件数 -->
    <el-table-column
      prop="dayQty"
      :label="$locale('dailyClosing.accountsReceivableTable.excessDeficiencySettlementTable.th.dayQty')"
      width="150"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">
          {{ scope.row.dayQty | separatorFormatter((isInitData && !isEmptyData) && actionType !== "detail") }}
          <!-- {{ scope.row.dayActualQty -  scope.row.actualQty | separatorFormatter((isInitData && !isEmptyData) && actionType !== "detail") }} -->
        </div>
      </template>
    </el-table-column>

    <!-- 日次実売上 -->
    <el-table-column
      prop="actualSales"
      :label="$locale('dailyClosing.accountsReceivableTable.excessDeficiencySettlementTable.th.actualSales')"
      width="150"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">
          {{ scope.row.actualSales | currencyFormatter((isInitData && !isEmptyData) && actionType !== "detail") }}
        </div>
      </template>
    </el-table-column>

    <!-- 合計過不足（売上）= レジ過不足（売上）+ 日次過不足（売上） -->
    <el-table-column
      prop="saleQty"
      :label="$locale('dailyClosing.accountsReceivableTable.excessDeficiencySettlementTable.th.saleQty')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">
          {{ scope.row.saleQty | currencyFormatter((isInitData && !isEmptyData) && actionType !== "detail") }}
          <!-- {{ (scope.row.actualAmount - scope.row.amount) - (scope.row.actualSales - scope.row.actualAmount) | currencyFormatter((isInitData && !isEmptyData) && actionType !== "detail") }} -->
        </div>
      </template>
    </el-table-column>

    <!-- レジ過不足（売上）= レジ実売上 - レジ理論売上 -->
    <el-table-column
      prop="cashBalance"
      :label="$locale('dailyClosing.accountsReceivableTable.excessDeficiencySettlementTable.th.cashBalance')"
      min-width="50"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">
          {{ scope.row.cashBalance | currencyFormatter((isInitData && !isEmptyData) && actionType !== "detail") }}
          <!-- {{ scope.row.actualAmount - scope.row.amount | currencyFormatter((isInitData && !isEmptyData) && actionType !== "detail") }} -->
        </div>
      </template>
    </el-table-column>

    <!-- 日次過不足（売上） = 日次実売上 - レジ実売上 -->
    <el-table-column
      prop="dayInsufficient"
      :label="$locale('dailyClosing.accountsReceivableTable.excessDeficiencySettlementTable.th.dayInsufficient')"
      min-width="50"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">
          {{ scope.row.dayInsufficient | currencyFormatter((isInitData && !isEmptyData) && actionType !== "detail") }}
          <!-- {{ scope.row.actualSales - scope.row.actualAmount | currencyFormatter((isInitData && !isEmptyData) && actionType !== "detail") }} -->
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import tranfResData from "@/utils/tranfResData";
import { ticketDetailResStruct } from "@/assets/js/dailyClosingNew";

export default {
  name: "TicketReplacement",
  props: {
    accountsReceivableType: {
      type: Object,
      default: () => ({}),
    },
    tableData: {
      type: Object,
      default: () => ({
        couponType: [],
        nationalTicket: [],
        settlement: [],
      }),
    },
    isInitData: {
      type: Boolean,
      default: true,
    },
    actionType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    blendData() {
      if (this.isEmptyData) {
        return [];
      }
      const _tableData = tranfResData(this.tableData);
      const _totalBase = ticketDetailResStruct();
      _totalBase.type = this.$locale("global.total");
      _totalBase.rowType = "total";

      let resultArray = [];

      const _addPropFn = (objArray, type) => {
        const _subTotalBase = ticketDetailResStruct();

        objArray.forEach((_item, i) => {
          _item.type = type;
          _item.index = i;

          const { actualAmount, amount, actualSales, dayActualQty, cashQty, actualQty } = _item;
          const _dayQty = dayActualQty - actualQty;
          const _cashBalance = actualAmount - amount;
          const _dayInsufficient = actualSales - actualAmount;

          _item.dayQty = _dayQty;
          _item.cashBalance = _cashBalance;
          _item.saleQty = _cashBalance - _dayInsufficient;
          _item.dayInsufficient = _dayInsufficient;
          _item.insufficientTotal = cashQty + _dayQty;

          if (i === 0) {
            _item.rowspan = objArray.length + 1;
            _item.colspan = 1;
          } else {
            _item.rowspan = 0;
            _item.colspan = 0;
          }

          for (let __key in _subTotalBase) {
            if (typeof _item[__key] === "number") {
              _subTotalBase[__key] += _item[__key];
              _totalBase[__key] += _item[__key];
            } else if (__key === "name") {
              _subTotalBase[__key] = this.accountsReceivableType[_item.type] + " " + this.$locale("global.total");
            }
          }
        });

        objArray.push({
          ..._subTotalBase,
          rowType: "subtotal",
          type,
        });

        return objArray;
      };

      Object.keys(_tableData).forEach(_key => {
        if (_tableData[_key].length > 0) {
          const _subList = _addPropFn(_tableData[_key], _key);
          resultArray.push(..._subList);
        }
      });

      resultArray.push(_totalBase);

      return resultArray;
    },
    isEmptyData() {
      const _tableData = tranfResData(this.tableData);
      const {
        couponType,
        nationalTicket,
        settlement,
      } = _tableData;

      if (couponType.length === 0 && nationalTicket.length === 0 && settlement.length === 0) {
        return true;
      }

      return false;
    },
  },
  methods: {
    spanMethod({ row, columnIndex }) {
      if (row.rowType === "total") {
        if (columnIndex === 0) {
          return [1, 2];

        } else if (columnIndex < 2) {
          return [0, 0];
        }
      }

      if (columnIndex === 0) {
        const { rowspan, colspan } = row;
        return [rowspan, colspan];
      }
    },
    rowClassName({ row }) {
      if (row.rowType === "subtotal") {
        return "sub-total-row";
      } else if (row.rowType === "total") {
        return "total-row";
      }
      return "";
    },
  },
};
</script>
